<template>
  <CosFullLayout>
    <template #aside>
      <RuleManage :listData="listData" @selectTag="selectTag"></RuleManage>
    </template>
    <template #main>
      <SaleCue :data="selectTagName"></SaleCue>
    </template>
  </CosFullLayout>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import RuleManage from './components/RuleManage.vue'
import SaleCue from './components/SaleCue.vue'
import type { IndexEchart } from '@/types/index'
import CosFullLayout from '@/components/CosFullLayout/index.vue'

export default defineComponent({
  name: 'DcCosLbuFollowRuleSetting',
  components: { RuleManage, SaleCue, CosFullLayout },
  setup() {
    const listData = [
      {
        title: '销售线索',
        target: 'saleCue'
      },
      {
        title: '潜在客户',
        target: 'potentialCustomer'
      },
      {
        title: '成交客户',
        target: 'successCustomer'
      },
      {
        title: '移动端-拜访签到设置',
        target: 'appSignSetting'
      },
      {
        title: '排休日设置',
        target: 'dayOffSetting'
      },
      {
        title: '商机提醒设置',
        target: 'businessSetting'
      },
      {
        title: '线索创建人设置',
        target: 'clueCreateSetting'
      }
    ]
    const selectTagName = ref<IndexEchart.RuleManageList>()
    const selectTag = (tagName: IndexEchart.RuleManageList) => {
      selectTagName.value = tagName
    }
    return { listData, selectTag, selectTagName }
  }
})
</script>
<style lang="scss" scoped></style>
